/**
 * GLSL shaders for auto-cannon tracer projectiles.
 * Instanced PlaneGeometry oriented on XZ plane, aligned to velocity direction.
 * Bright orange-yellow tracers with hot white core, HDR bloom.
 */

export const tracerVertexShader = /* glsl */ `
  varying vec2 vUv;

  void main() {
    vUv = uv;
    vec4 worldPos = instanceMatrix * vec4(position, 1.0);
    gl_Position = projectionMatrix * modelViewMatrix * worldPos;
  }
`;

export const tracerFragmentShader = /* glsl */ `
  varying vec2 vUv;

  void main() {
    // UV.x: 0=left edge, 1=right edge. Core at 0.5.
    // UV.y: 0=tail, 1=head.

    // Lateral falloff — hot white center, orange edges
    float lateral = 1.0 - abs(vUv.x - 0.5) * 2.0; // 1 at center, 0 at edges
    float coreFalloff = smoothstep(0.0, 0.6, lateral); // soft edge
    float hotCore = smoothstep(0.4, 0.9, lateral);      // tight hot center

    // Longitudinal — bright head, gradual tail fade
    float headFade = smoothstep(0.0, 0.15, vUv.y);   // fade in at tail tip
    float intensity = coreFalloff * mix(0.5, 1.0, vUv.y) * headFade;

    if (intensity < 0.02) discard;

    // Color: hot white core → bright yellow → orange at edges
    vec3 orange = vec3(1.0, 0.5, 0.05);
    vec3 yellow = vec3(1.0, 0.85, 0.2);
    vec3 white = vec3(1.0, 1.0, 0.9);

    vec3 color = mix(orange, yellow, coreFalloff);
    color = mix(color, white, hotCore * 0.8);

    // Boost head brightness
    color *= mix(0.7, 1.3, vUv.y);

    // HDR for bloom — tracers should GLOW
    float hdr = 5.0;

    gl_FragColor = vec4(color * hdr * intensity, intensity);
  }
`;

export const impactVertexShader = /* glsl */ `
  varying vec2 vUv;

  void main() {
    vUv = uv;
    vec4 worldPos = instanceMatrix * vec4(position, 1.0);
    gl_Position = projectionMatrix * modelViewMatrix * worldPos;
  }
`;

export const impactFragmentShader = /* glsl */ `
  varying vec2 vUv;

  void main() {
    // Radial distance from center
    float dist = length(vUv - 0.5) * 2.0;

    // Soft circle with hot center
    float alpha = 1.0 - smoothstep(0.0, 1.0, dist);
    float hotCenter = 1.0 - smoothstep(0.0, 0.3, dist);
    if (alpha < 0.01) discard;

    // Bright white-yellow center, orange outer ring
    vec3 inner = vec3(1.0, 1.0, 0.9);
    vec3 outer = vec3(1.0, 0.6, 0.1);
    vec3 color = mix(outer, inner, hotCenter);

    float hdr = 8.0;

    gl_FragColor = vec4(color * hdr * alpha, alpha);
  }
`;
